import { styled } from "@linaria/react"

import type { Property } from "csstype"

export const Flex = styled.div`
  display: flex;
`

export const Vertical = styled.div<{
  inline?: boolean
  alignItems?: Property.AlignItems
  alignSelf?: Property.AlignSelf
  justifyContent?: Property.JustifyContent
  wrap?: Property.FlexWrap
  flex?: Property.Flex
  gap?: Property.Gap
  width?: Property.Width
  height?: Property.Height
}>`
  display: ${props => props.inline === true ? "inline-flex" : "flex"};
  flex-direction: column;

  /* stylelint-disable declaration-block-no-redundant-longhand-properties */
  align-items: ${props => props.alignItems || "normal"};
  align-self: ${props => props.alignSelf || "auto"};
  justify-content: ${props => props.justifyContent || "normal"};
  flex-wrap: ${props => props.wrap || "nowrap"};
  flex: ${props => props.flex || "0 1 auto"};
  gap: ${props => props.gap || "normal"};
  width: ${props => props.width || "auto"};
  height: ${props => props.height || "auto"};
  /* stylelint-enable declaration-block-no-redundant-longhand-properties */
`

export const Horizontal = styled.div<{
  inline?: boolean
  alignItems?: Property.AlignItems
  alignSelf?: Property.AlignSelf
  justifyContent?: Property.JustifyContent
  wrap?: Property.FlexWrap
  flex?: Property.Flex
  gap?: Property.Gap
  width?: Property.Width
  height?: Property.Height
}>`
  display: ${props => props.inline === true ? "inline-flex" : "flex"};

  align-items: ${props => props.alignItems || "normal"};
  align-self: ${props => props.alignSelf || "auto"};
  justify-content: ${props => props.justifyContent || "normal"};
  flex-wrap: ${props => props.wrap || "nowrap"};
  flex: ${props => props.flex || "0 1 auto"};
  gap: ${props => props.gap || "normal"};
  width: ${props => props.width || "auto"};
  height: ${props => props.height || "auto"};
`

export const Spring = styled.div`
  display: flex;
  flex: 1 10 1px;
  min-width: 0;
`

export const Gap = styled.div<{
  width?: Property.Width
  height?: Property.Height
}>`
  flex: 0 0 auto;

  width: ${props => props.width || "auto"};
  height: ${props => props.height || "auto"};
`
